module.exports = __webpack_public_path__ + "static/media/mainBcg.984874d1.jpeg";